import React from 'react';

interface BannerStylesCustomizationProps {
    backgroundColor: string;
    setBackgroundColor: (val: string) => void;
    eyebrowColor: string;
    setEyebrowColor: (val: string) => void;
    titleColor: string;
    setTitleColor: (val: string) => void;
    subtitleColor: string;
    setSubtitleColor: (val: string) => void;
    buttonColor: string;
    setButtonColor: (val: string) => void;
    disabled: boolean;
}

const BannerStylesCustomization: React.FC<BannerStylesCustomizationProps> = ({
    backgroundColor, setBackgroundColor,
    eyebrowColor, setEyebrowColor,
    titleColor, setTitleColor,
    subtitleColor, setSubtitleColor,
    buttonColor, setButtonColor,
    disabled
}) => {
    const [activeFocus, setActiveFocus] = React.useState<string | null>(null);

    const handleReceiveFocus = (element: string) => {
        setActiveFocus(element);
    };

    const handleMouseEnter = (element: string) => {
        if (activeFocus && activeFocus !== element) {
            setActiveFocus(null);
        }
    };

    const handleMouseLeave = () => {
        if (!activeFocus) {
            setActiveFocus(null);
        }
    };

    return (
        <div className="banner-styles-section">
            <div className="banner-input-wrapper">
                <p>
                    <b>Banner Colors</b>
                </p>
                <div className="color-input-wrapper-banner">
                    <label
                        className="color"
                        onMouseEnter={() => handleMouseEnter('bg')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <p>Background</p>
                        <input
                            type="color"
                            value={backgroundColor}
                            onChange={(e) => setBackgroundColor(e.target.value)}
                            disabled={disabled}
                            onFocus={() => handleReceiveFocus('bg')}
                            onClick={() => handleReceiveFocus('bg')}
                        />
                    </label>

                    <label
                        className="color"
                        onMouseEnter={() => handleMouseEnter('eyebrow')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <p>Eyebrow Text</p>
                        <input
                            type="color"
                            value={eyebrowColor}
                            onChange={(e) => setEyebrowColor(e.target.value)}
                            disabled={disabled}
                            onFocus={() => handleReceiveFocus('eyebrow')}
                            onClick={() => handleReceiveFocus('eyebrow')}
                        />
                    </label>

                    <label
                        className="color"
                        onMouseEnter={() => handleMouseEnter('title')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <p>Title Text</p>
                        <input
                            type="color"
                            value={titleColor}
                            onChange={(e) => setTitleColor(e.target.value)}
                            disabled={disabled}
                            onFocus={() => handleReceiveFocus('title')}
                            onClick={() => handleReceiveFocus('title')}
                        />
                    </label>

                    <label
                        className="color"
                        onMouseEnter={() => handleMouseEnter('subtitle')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <p>Subtitle Text</p>
                        <input
                            type="color"
                            value={subtitleColor}
                            onChange={(e) => setSubtitleColor(e.target.value)}
                            disabled={disabled}
                            onFocus={() => handleReceiveFocus('subtitle')}
                            onClick={() => handleReceiveFocus('subtitle')}
                        />
                    </label>

                    <label
                        className="color"
                        onMouseEnter={() => handleMouseEnter('button')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <p>Button</p>
                        <input
                            type="color"
                            value={buttonColor}
                            onChange={(e) => setButtonColor(e.target.value)}
                            disabled={disabled}
                            onFocus={() => handleReceiveFocus('button')}
                            onClick={() => handleReceiveFocus('button')}
                        />
                    </label>
                </div>
            </div>
        </div>
    );
};

export default BannerStylesCustomization;